import { render, staticRenderFns } from "./ModalDeRecusarTermos.vue?vue&type=template&id=3ff622a1"
import script from "./ModalDeRecusarTermos.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDeRecusarTermos.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports